module.exports = "/_next/static/images/Protocols-03a15c3951401aa94f184a821a8c6d23.webp";